import { Box, Container } from "@mui/material";
import React, { useEffect } from "react";
import { Markdown } from "src/components/markdown";
import { MainLayout } from "src/layouts/main";

const PrivacyPolicy = () => {
  useEffect(() => {
    // window.location.href = "https://riple.org/privacy-policy.html";
  }, []);
  return (
    <MainLayout>
      <Container sx={{ py: 5 }}>
        <Markdown>
          {`# **Privacy Policy**
\n
\n

This Privacy Policy describes our policies and procedures on the collection, use, and disclosure of your information when you use the Service. It also explains your privacy rights and how the law protects you.

We use your personal data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.

---

## **Interpretation and Definitions**

### **Interpretation**

Words with capitalized initial letters have defined meanings under the conditions outlined below. These definitions apply whether the terms appear in singular or plural form.

### **Definitions**

For the purposes of this Privacy Policy:

* **Account** means a unique account created for you to access our Service or parts of our Service.

* **Affiliate** means an entity that controls, is controlled by, or is under common control with a party. "Control" means ownership of 50% or more of the shares, equity interest, or other securities entitled to vote for election of directors or other managing authority.

* **Application** means the software program provided by the Company, downloaded by you on any electronic device, named *riple*.

* **Company** (referred to as either "the Company", "We", "Us", or "Our" in this Agreement) refers to *riple Inc.*

* **Country** refers to the United Kingdom.

* **Device** means any device that can access the Service, such as a computer, cellphone, or digital tablet.

* **Personal Data** is any information that relates to an identified or identifiable individual.

* **Service** refers to the Application.

* **Service Provider** means any natural or legal person who processes data on behalf of the Company. This includes third-party companies or individuals employed by the Company to:

  * Facilitate the Service
  * Provide the Service on behalf of the Company
  * Perform services related to the Service
  * Assist the Company in analyzing how the Service is used

* **Third-party Social Media Service** refers to any website or social network through which a user can log in or create an account to use the Service.

* **Usage Data** refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (e.g., the duration of a page visit).

* **You** means the individual accessing or using the Service, or the company or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.

---

## **Collecting and Using Your Personal Data**

### **Types of Data Collected**

#### **Personal Data**

While using our Service, we may ask you to provide certain personally identifiable information that can be used to contact or identify you. This may include, but is not limited to:

* Email address
* First name and last name
* Usage Data

#### **Usage Data**

Usage Data is collected automatically when using the Service.

This may include information such as:

* Your device’s Internet Protocol address (e.g., IP address)
* Browser type and version
* Pages visited within the Service
* Date and time of visit
* Time spent on pages
* Unique device identifiers
* Other diagnostic data

When accessing the Service via a mobile device, additional information may be collected, such as:

* Type of mobile device
* Unique mobile device ID
* IP address of the mobile device
* Mobile operating system
* Type of mobile Internet browser used
* Other diagnostic data

We may also collect information that your browser sends whenever you visit our Service or access it through a mobile device.

---

### **Information from Third-party Social Media Services**

The Company allows you to create an account and log in using the following Third-party Social Media Services:

* Google
* Apple
* Facebook
* LinkedIn

If you register through or grant access to a Third-party Social Media Service, we may collect personal data associated with your account on that service. This can include:

* Your name
* Your email address
* Activities
* Contact list

You may also have the option to share additional information with the Company through your Third-party Social Media Service account. If you choose to do so, you give the Company permission to use, share, and store this data in accordance with this Privacy Policy.

---

### **Information Collected While Using the Application**

To provide features of our Application, we may collect the following information, with your prior permission:

* Location data
* Pictures and other information from your device’s camera and photo library

This information is used to provide and improve our services. It may be uploaded to the Company’s servers or those of a Service Provider, or simply stored on your device.

You can enable or disable access to this information at any time through your device settings.`}
        </Markdown>
      </Container>
    </MainLayout>
  );
};

export default PrivacyPolicy;
